import { Request } from "./HttpService";

export const scheduleSearchService = {

    getMySearches() {
        return Request("vitae/scheduleSearch", "GET");
    },
    activateSearch(searchId) {
        return Request(`vitae/scheduleSearch/activate/${searchId}`, "PUT");
    },
    deactivateSearch(searchId) {
        return Request(`vitae/scheduleSearch/deactivate/${searchId}`, "PUT");
    },  
    deleteSearch(searchId) {    
        return Request(`vitae/scheduleSearch/${searchId}`, "DELETE");
    },
    saveSearch(search) {
        return Request("vitae/scheduleSearch", "POST", search);
    }

};